import { initYear, MSG030 } from "./Constantes";


export function validaMayorEdad (fecha) {
  if(calcularEdad(fecha) >= 18){
    return true;
  } else {
    return false;
  }
};

/**
 * recibe cumple como  fecha completa new Date()
 */
export function calcularEdad(cumple) {
  var hoy = new Date();
  var edad = hoy.getFullYear() - cumple.getFullYear();
  var m = hoy.getMonth() - cumple.getMonth();
  if (m < 0 || (m === 0 && hoy.getDate() < cumple.getDate())) {
      edad--;
  }
  return edad;
}

export function fillYears() {
  let years = [];
  const maxYear = new Date();
  for (let index = maxYear.getFullYear(); index > initYear; index--) {
    years.push(index)
  }
  return years;
}


export function maxLength(value, maxLength) {
  var res = String(value);
  if(res.length > maxLength){
    return res.substring(0,maxLength);
  } else {
    return res;
  }
}


export const handleError = (error, origen, setDialogo) => {
  console.error("Origen del error: ".concat(origen));
  setDialogo((val) => ({
    ...val,
    open: true,
    titulo: "Error en consulta",
    descripcion: descripcionError(error, MSG030),
  }));
};

export function descripcionError(error, mensajeDefault){
  var errorText = mensajeDefault;
  if (error.response) {
    /*
    * The request was made and the server responded with a
    * status code that falls out of the range of 2xx
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.statusText);
    console.log(error.response.headers);
    */
    errorText = error.response.data != null ? 
                  error.response.data.errorMessage != null ? 
                    error.response.data.errorMessage : validaStatus(error.response)
                      : validaStatus(error.response)
  } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    console.log(error.request);
  } else {
    // Something happened in setting up the request and triggered an Error
    console.log('Error', error.message);
  }
  return errorText;
}

function validaStatus(response){
  if(response.status === 400){
    return MSG030;
  } else {
    return response.statusText;
  }
}

export function validaResponse(res){
  if(res.status === 200 && res.data){
    return true;
  } else {
    return false;
  }
}

export function generoValueToService(genero){
  return (genero === 0 ? "Masculino" : "Femenino");
}

export function serviceToGeneroValue(genero){
  return (genero === "Masculino" ? 0 : 1);
}
